import {
    UPDATE_REPERTOIRE,

    GET_REPERTOIRE_REQUEST,
    GET_REPERTOIRE_SUCCESS,
    GET_REPERTOIRE_FAIL,

    GET_ALL_REPERTOIRES_REQUEST,
    GET_ALL_REPERTOIRES_SUCCESS,
    GET_ALL_REPERTOIRES_FAIL,

    GET_REPERTOIRE_TREE_REQUEST,
    GET_REPERTOIRE_TREE_SUCCESS,
    GET_REPERTOIRE_TREE_FAIL,

    GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST,
    GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS,
    GET_AUTHORIZED_REPERTOIRE_TREE_FAIL,

    GET_REPERTOIRES_BY_STATUS_REQUEST,
    GET_REPERTOIRES_BY_STATUS_SUCCESS,
    GET_REPERTOIRES_BY_STATUS_FAIL,

    CREATE_REPERTOIRE_REQUEST,
    CREATE_REPERTOIRE_SUCCESS,
    CREATE_REPERTOIRE_FAIL,

    UPDATE_REPERTOIRE_REQUEST,
    UPDATE_REPERTOIRE_SUCCESS,
    UPDATE_REPERTOIRE_FAIL,

    CHANGE_REPERTOIRE_STATUS_REQUEST,
    CHANGE_REPERTOIRE_STATUS_SUCCESS,
    CHANGE_REPERTOIRE_STATUS_FAIL,

    DELETE_REPERTOIRE_REQUEST,
    DELETE_REPERTOIRE_SUCCESS,
    DELETE_REPERTOIRE_FAIL,

    SET_REPERTOIRE_LOADING,
    CLEAR_REPERTOIRE_MESSAGE,
    CLEAR_REPERTOIRE_ERROR
} from '../actions/repertoireActions';

const initialState = {
    repertoires: [],
    repertoireTree: [],
    authorizedRepertoireTree: [],
    currentRepertoire: null,
    loading: false,
    message: '',
    error: null
};

function repertoireReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_REPERTOIRE:
            return {
                ...state,
                currentRepertoire: action.repertoire
            };

        case SET_REPERTOIRE_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case CLEAR_REPERTOIRE_MESSAGE:
            return {
                ...state,
                message: ''
            };

        case CLEAR_REPERTOIRE_ERROR:
            return {
                ...state,
                error: null
            };

        case GET_REPERTOIRE_REQUEST:
        case GET_ALL_REPERTOIRES_REQUEST:
        case GET_REPERTOIRE_TREE_REQUEST:
        case GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST:
        case GET_REPERTOIRES_BY_STATUS_REQUEST:
        case CREATE_REPERTOIRE_REQUEST:
        case UPDATE_REPERTOIRE_REQUEST:
        case CHANGE_REPERTOIRE_STATUS_REQUEST:
        case DELETE_REPERTOIRE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_REPERTOIRE_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false
            };

        case GET_ALL_REPERTOIRES_SUCCESS:
        case GET_REPERTOIRES_BY_STATUS_SUCCESS:
            return {
                ...state,
                repertoires: action.payload,
                loading: false,
                error: null
            };

        case GET_REPERTOIRE_TREE_SUCCESS:
            return {
                ...state,
                repertoireTree: action.payload,
                loading: false,
                error: null
            };

        case GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS:
            return {
                ...state,
                authorizedRepertoireTree: action.payload,
                loading: false,
                error: null
            };

        case CREATE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Répertoire créé avec succès'
            };

        case UPDATE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false,
                message: 'Répertoire mis à jour avec succès'
            };

        case CHANGE_REPERTOIRE_STATUS_SUCCESS:
            return {
                ...state,
                currentRepertoire: action.payload,
                loading: false,
                message: 'Statut mis à jour avec succès'
            };

        case DELETE_REPERTOIRE_SUCCESS:
            return {
                ...state,
                loading: false,
                message: 'Répertoire supprimé avec succès'
            };

        case GET_REPERTOIRE_FAIL:
        case GET_ALL_REPERTOIRES_FAIL:
        case GET_REPERTOIRE_TREE_FAIL:
        case GET_AUTHORIZED_REPERTOIRE_TREE_FAIL:
        case GET_REPERTOIRES_BY_STATUS_FAIL:
        case CREATE_REPERTOIRE_FAIL:
        case UPDATE_REPERTOIRE_FAIL:
        case CHANGE_REPERTOIRE_STATUS_FAIL:
        case DELETE_REPERTOIRE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state;
    }
}

export default repertoireReducer;